<template>
  <div>
    <div class="my-rank-box">
      <div class="rank-detail-box">
        <div class="rank-detail-text">MY RANK</div>
        <div class="rank-detail">
          <div class="triangle"></div>
          12
        </div>
      </div>
      <div class="my-rank-info-box">
        <div class="my-rank-info">
          <div class="user-info-box">
            <div class="user-img">
              <img src="@/assets/image/driver-img.png" alt="" />
            </div>
            <div class="user-info">
              <div>Sammy</div>
              <div>5 yrs driver</div>
            </div>
          </div>
          <div class="safety-score-info">
            <div>Safety score</div>
            <div>85.25</div>
          </div>
        </div>
      </div>
    </div>
    <div class="performance-box">Group’s performance</div>
    <div class="performance-list-box" v-for="index in 4" :key="index">
      <div class="performance-list-detail">
        <div class="list-number">1</div>
        <div class="list-img">
          <img src="@/assets/image/drivers-img.png" alt="" />
        </div>
        <div class="list-user-info">
          <div>Abdul Bowie</div>
          <div>5 yrs driver</div>
        </div>
        <div class="list-charts-box">
          <div :id="'chartHistoryScore-' + index" class="list-charts"></div>
        </div>
        <div class="list-safety-score">
          <div>Safety score</div>
          <div>98.84</div>
        </div>
      </div>
    </div>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import * as echarts from "echarts";
import Tabbar from "@/components/Tabbar";
export default {
  components: {
    Tabbar,
  },
  data() {
    return {};
  },
  mounted() {
    this.chartHistoryScoreEvent();
  },
  methods: {
    chartHistoryScoreEvent() {
      // 获取容器元素
      for (let index = 1; index <= 4; index++) {
        const chartContainer = document.getElementById(
          "chartHistoryScore-" + index
        );
        const myChart = echarts.init(chartContainer);
        // 定义图表配置项
        const options = {
          xAxis: {
            show: false, // 隐藏 x 轴展示条
            type: "category",
            boundaryGap: false,
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
          yAxis: {
            show: false, // 隐藏 y 轴展示条
            type: "value",
          },
          grid: {
            left: "-25%",
            right: "5%",
            top: "30%",
            bottom: "0%",
            containLabel: true,
          },
          tooltip: {
            show: true, // 显示tooltip
            trigger: "axis", // 触发方式为坐标轴触发
            backgroundColor: "#000", // tooltip背景颜色
            textStyle: {
              color: "#fff",
            },
            formatter: function (params) {
              // 自定义tooltip内容
              return (
                `<span style="font-size: 12px;">Dec 16</span><br>` +
                `<span style="font-size: 16px;">${params[0].value} <span style="font-size: 12px;">pts</span></span>`
              );
            },
          },
          series: [
            {
              data: [120, 932, 501, 134, 901, 634, 1003],
              type: "line",
              showSymbol: false,
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "white", // 渐变起始颜色
                    },
                    {
                      offset: 1,
                      color: "#8ddcba", // 渐变结束颜色
                    },
                  ],
                },
              },
              lineStyle: {
                color: "#02BF72", // 折线颜色
              },
              symbol: "circle", // 点的样式为实心圆
              symbolSize: 6, // 点的大小
              itemStyle: {
                color: "#02BF72", // 点的颜色
              },
            },
          ],
        };
        // 使用配置项绘制图表
        myChart.setOption(options);
        myChart.resize = true;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.my-rank-box {
  width: 361px;
  height: 80px;
  // border: 1px solid;
  margin: 17px auto;
  display: flex;
  justify-content: space-between;
  .rank-detail-box {
    width: 80px;
    height: 80px;
    background: #f7f7f7;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .rank-detail-text {
      width: 69px;
      height: 18px;
      font-size: 12px;
      font-family: SFCompactText, SFCompactText;
      font-weight: 500;
      color: #98a2b6;
      line-height: 18px;
      margin-bottom: 12px;
    }
    .rank-detail {
      font-size: 24px;
      font-family: SFProText, SFProText;
      font-weight: 500;
      color: #333333;
      line-height: 18px;
      display: flex;
      .triangle {
        width: 0;
        height: 0;
        margin-right: 8px;
        border-top: 6px solid transparent; /* 上边框 */
        border-right: 4px solid transparent; /* 右边框 */
        border-left: 4px solid transparent; /* 右边框 */
        border-bottom: 6px solid #5abb6e; /* 下边框 */
      }
    }
  }
  .my-rank-info-box {
    width: 271px;
    height: 80px;
    background: #f7f7f7;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    .my-rank-info {
      width: 243px;
      height: 44px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .user-info-box {
        // width: 134px;
        height: 44px;
        display: flex;
        align-items: center;
        .user-img {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 8px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .user-info {
          // width: 82px;
          max-width: 122px;
          height: 37px;
          div:nth-child(1) {
            max-width: 122px;
            height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #200e32;
            line-height: 20px;
          }
          div:nth-child(2) {
            height: 17px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
          }
        }
      }
      .safety-score-info {
        width: 59px;
        height: 38px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        div:nth-child(1) {
          // width: 59px;
          height: 14px;
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 14px;
          text-align: center;
        }
        div:nth-child(2) {
          //  width: 46px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #200e32;
          text-align: center;
          line-height: 22px;
        }
      }
    }
  }
}
.performance-box {
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #200e32;
  line-height: 25px;
  margin-left: 16px;
}
.performance-list-box {
  width: 361px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  margin: 12px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .performance-list-detail {
    width: 343px;
    height: 44px;
    display: flex;
    align-items: center;
    .list-number {
      width: 17px;
      height: 18px;
      font-size: 14px;
      font-family: SFProText, SFProText;
      font-weight: bold;
      color: #98a2b6;
      line-height: 18px;
      text-align: center;
    }
    .list-img {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .list-user-info {
      width: 84px;
      height: 37px;
      // border: 1px solid;
      div:nth-child(1) {
        width: 84px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #200e32;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      div:nth-child(2) {
        width: 63px;
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
    }
    .list-charts-box {
      width: 102px;
      height: 44px;
      // border: 1px solid;
      margin: 0 11px 0 10px;
      // position: relative;
      .list-charts {
        width: 100%;
        height: 100%;
        // position: absolute;
        // top: 0px;
      }
    }
    .list-safety-score {
      width: 59px;
      height: 38px;
      div:nth-child(1) {
        width: 59px;
        height: 14px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        margin-bottom: 2px;
      }
      div:nth-child(2) {
        // width: 46px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #200e32;
        text-align: center;
        line-height: 22px;
      }
    }
  }
}
</style>